import React, { useState } from "react";
import { Row, Col } from "reactstrap";
import { useHistory } from "react-router-dom";

import eyeIcon from "../../../assets/images/app/allaya/eye-icon.svg";
import editIcon from "../../../assets/images/app/allaya/edit-icon.svg";
import deleteIcon from "../../../assets/images/app/allaya/delete-icon.svg";
import { ReactComponent as FilterIcon } from "../../../assets/images/app/allaya/filter-autocomplete.svg";

import { SearchBox } from "../../../components/SearchBox";
import { transformFiltersToArray, truncateString } from "../../../utils/commonUtils";
import { DataTable } from "../../../components/DataTable";
import { LABELS } from "../Config";
import { UserStatus } from "../../../constants";
import { APP_ROUTES, getParamsAttachedRoute } from "../../../helpers/routeHelpers";
import { getKey, MODULE_KEYS } from "../../../api/api.keys";
import { useLocalPaginatedRequest } from "../../../hooks/useLocalPaginatedRequest";
import { DeleteAuthorById, GetAuthorListing } from "../../../api/api.service";
import { Pagination } from "../../../components/Pagination";
import { ConfirmationModal } from "../../../components/CustomModal";
import { useRequestProcessor } from "../../../hooks/useRequestProcessors";
import GoalStatus, { GOAL_STATUS } from "../../../constants/GoalStatus";
import { FilterChips } from "../../AudioContentManagement/FilterChips";
import AuthorFilterModal from "./AuthorFilterModal";
import { CustomButton } from "../../../components/CustomButton";

let { NAME, NO_OF_AUDIOS, STATUS, ACTION, DEGREE, LICENSE } = LABELS;
const CHARACTER_LIMIT = 30;

const AuthorListing = () => {
    const history = useHistory();
    const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
    const [selectedId, setSelectedId] = useState();
    const { useMutate } = useRequestProcessor();

    const { mutate: deleteJobMutate, isLoading } = useMutate("", getKey(), (data) =>
        DeleteAuthorById(selectedId)
    );

    const [isFilterModal, setIsFilterModal] = useState(false);
    const [filters, setFilters] = useState({
        subCategory: [],
        status: [],
        audioType: []
    });

    const {
        isFetching,
        page,
        handlePageClick,
        total,
        data,
        searchText,
        limit,
        handleSearchChange,
        handleSortingChange,
        refetch
    } = useLocalPaginatedRequest({
        key: getKey([MODULE_KEYS.AUTHOR_MANAGEMENT]),
        requestFn: GetAuthorListing,
        dataKey: "data",
        totalKey: "total",
        params: {
            ...(filters.status?.value && {
                status:
                    filters.status?.value === "Active" ? GOAL_STATUS.ACTIVE : GOAL_STATUS.INACTIVE
            })
        }
    });

    const openFilterModal = () => setIsFilterModal(true);

    const handleApplyFilter = (newFilters) => {
        setFilters(newFilters);
        setIsFilterModal(false);
    };

    const handleRemoveFilter = (type, value) => {
        setFilters((prevFilters) => {
            const updatedFilters = { ...prevFilters };

            if (Array.isArray(updatedFilters[type])) {
                updatedFilters[type] = updatedFilters[type].filter((item) => item.value !== value);
            }

            if (typeof updatedFilters[type] === "object" && updatedFilters[type] !== null) {
                if (updatedFilters[type].value === value) {
                    updatedFilters[type] = null;
                }
            }

            return updatedFilters;
        });
    };

    const handleDeleteGoal = () => {
        deleteJobMutate(Number(selectedId), {
            onSuccess: () => {
                refetch();
                setIsDeleteModalOpen(false);
                setSelectedId(undefined);
            }
        });
    };

    return (
        <div>
            <Row className="px-3">
                <Col sm="12" align="right" className="pt-3">
                    <CustomButton
                        title="Add Author"
                        color="primary"
                        icon={<i className="bx bx-plus"></i>}
                        className="custom-btn-lg"
                        onClick={() => history.push(APP_ROUTES.AUTHOR_ADD)}
                    />
                </Col>

                <Col sm="12" md="4" lg="4" className="pt-3">
                    <SearchBox
                        className="me-3 w-50"
                        value={searchText}
                        onChange={handleSearchChange}
                    />
                </Col>
                <Col sm="12" md="5" lg="5"></Col>

                <Col sm="12" md="3" lg="3" className="pt-3">
                    <div
                        className={`filter-container d-flex justify-content-between align-items-center pointer`}
                        onClick={openFilterModal}
                    >
                        <div className="position-relative filter-text">Filter By</div>
                        <div className="">
                            <FilterIcon />
                        </div>
                    </div>
                </Col>
            </Row>

            <Row className="px-3 my-2">
                <FilterChips
                    filters={transformFiltersToArray(filters)}
                    onRemove={handleRemoveFilter}
                />
            </Row>

            <DataTable
                tableContainerClass=""
                loading={isFetching}
                data={data}
                config={[
                    {
                        title: NAME,
                        render: (data) => (
                            <div data-container={data?.name}>
                                {truncateString(data?.name, CHARACTER_LIMIT) || "-"}
                            </div>
                        )
                    },
                    {
                        title: DEGREE,

                        render: (data) => (
                            <div data-container={data?.degree}>
                                {truncateString(data?.degree, CHARACTER_LIMIT) || "-"}
                            </div>
                        )
                    },
                    {
                        title: LICENSE,
                        render: (data) => (
                            <div data-container={data?.license}>
                                {truncateString(data?.license, CHARACTER_LIMIT) || "-"}
                            </div>
                        )
                    },
                    {
                        title: NO_OF_AUDIOS,
                        render: (data) => <div>{data?.totalAudios || 0}</div>
                    },
                    {
                        title: STATUS,
                        render: (data) => (
                            <div
                                className={`status-common-class ${UserStatus.getLabelClass(
                                    data?.status
                                )}`}
                            >
                                {GoalStatus.getDisplayTextKey(data?.status) || "-"}
                            </div>
                        )
                    },
                    {
                        title: ACTION,
                        render: (data) => {
                            return (
                                <div className="d-flex ">
                                    <img
                                        className="me-1"
                                        src={eyeIcon}
                                        alt={"view"}
                                        role="button"
                                        onClick={() => {
                                            history.push(
                                                getParamsAttachedRoute(APP_ROUTES.AUTHOR_DETAILS, {
                                                    id: data?.id
                                                })
                                            );
                                        }}
                                    />

                                    <img
                                        className="me-2"
                                        src={editIcon}
                                        alt={"edit"}
                                        role="button"
                                        onClick={() =>
                                            history.push(
                                                getParamsAttachedRoute(APP_ROUTES.AUTHOR_EDIT, {
                                                    id: data?.id
                                                })
                                            )
                                        }
                                    />
                                    <img
                                        className="me-1"
                                        src={deleteIcon}
                                        alt={"delete"}
                                        role="button"
                                        onClick={() => {
                                            setSelectedId(data?.id);
                                            setIsDeleteModalOpen(true);
                                        }}
                                    />
                                </div>
                            );
                        }
                    }
                ]}
            />

            <Pagination
                rowLimit={limit}
                onPageClick={handlePageClick}
                currentPage={page}
                totalData={total}
                handleChange={(e) => handleSortingChange(e.target.value)}
            />

            <ConfirmationModal
                size="md"
                hasCustomConfig
                customSubText={"Are you sure you want to delete this author?"}
                customYesBtnText={"Delete"}
                customNoBtnText={"Cancel"}
                isOpen={isDeleteModalOpen}
                onYes={handleDeleteGoal}
                onNo={() => setIsDeleteModalOpen(false)}
                yesLoading={isLoading}
                customImageSrc={deleteIcon}
            />
            <AuthorFilterModal
                isModalOpen={isFilterModal}
                handleClose={() => setIsFilterModal(false)}
                handleApplyFilter={handleApplyFilter}
                selectedFilters={filters} // Pass the current filters to the modal
            />
        </div>
    );
};

export default AuthorListing;
